import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import OAuth from "../components/OAuth";

export default function ForgotPassword() {
	// const [showPassword, setShowPassword] = useState(false);
	const [formData, setFormData] = useState({
		email: "",
	});
	const { email } = formData;
	function onChange(e) {
		setFormData((prevState) => ({
			...prevState,
			[e.target.id]: e.target.value,
		}));
	}

	async function onSubmit(e) {
		e.preventDefault();

		try {
			const auth = getAuth();
			await sendPasswordResetEmail(auth, email);
			toast.success("Email was sent");
		} catch (error) {
			toast.error("Could not send reset password");
		}
	}

	return (
		<div className="flex flex-wrap-reverse items-center py-20">
			<div className="h-full w-full lg:w-1/2 justify-center">
				<h1 className="text-8xl font-extralight text-center">
					Parvind's Blog
				</h1>
			</div>
			<div className="text-sm w-full lg:w-1/2 flex items-center text-center justify-center">
				<form
					onSubmit={onSubmit}
					className="w-full mx-20 mb-10"
				>
					<h1 className="font-bold text-xl my-5">Reset Password</h1>
					<input
						className="p-2 mb-4 w-3/4 text-gray-800 bg-gray-200 px-4 py-2 text-lg rounded-md transition ease-in-out"
						type="email"
						id="email"
						value={email}
						onChange={onChange}
						placeholder="Email Address"
					/>

					<div className="mx-auto flex justify-between w-3/4 text-xs sm:text-sm whitespace-nowrap mb-4">
						<p>
							Don't have an account?
							<Link
								className="text-red-500 hover:text-red-600 transition duration-200 ease-in-out ml-1"
								to="/sign-up"
							>
								Register
							</Link>
						</p>
						<p>
							<Link
								className="text-blue-500 hover:text-blue-600 transition duration-200 ease-in-out"
								to="/sign-in"
							>
								Sign in instead
							</Link>
						</p>
					</div>
					<button className="bg-blue-600 hover:bg-blue-700 w-3/4 p-2 text-white rounded-md shadow-md uppercase font-medium">
						Send Reset Email
					</button>
					<div className="flex before:flex-1 before:border-t before:border-gray-600 after:flex-1 after:border-t after:border-gray-600 mx-auto my-2 w-3/4 text-center items-center justify-center">
						<p className="mx-2">OR</p>
					</div>
					<OAuth />
				</form>
			</div>
		</div>
	);
}
